import { render, staticRenderFns } from "./SellersView.vue?vue&type=template&id=7a5214e4&scoped=true&"
import script from "./SellersView.vue?vue&type=script&lang=js&"
export * from "./SellersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5214e4",
  null
  
)

export default component.exports